import { isMacOS, isWindows } from "@/utils/platform";


function getBaseUrl() {
  if (isWindows()) {
    return 'http://ac.localhost/api/v1/';
  } else if (isMacOS) {
    return 'anycubic://localhost/api/v1/';
  } else {
    return '';
  }
}

const baseURL = getBaseUrl();

function COMMON(module, resource, method, data) {
  const url = baseURL + module + '/' + resource;
  return fetch(url, {
    method: method,
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(response => response.json());
}

function SendDelete(module, resource, data) {
  return COMMON(module, resource, 'DELETE', data);
}
function SendPOST(module, resource, data) {
  return COMMON(module, resource, 'POST', data);
}
function SendPUT(module, resource, data) {
  return COMMON(module, resource, 'PUT', data);
}
function SendGET(module, resource, data) {

  let url = baseURL + module + '/' + resource;
  if (data != null) {
    const searchParams = new URLSearchParams(data);

    if (searchParams.toString && searchParams.toString() != '') {
      url = url + "?" + searchParams.toString();
    } else {
      console.log('SendGET error toString undefined', url, data)
    }
  }
  return fetch(url, { method: 'GET' }).then(response => response.json());
}


async function get(module, resource, params = {}) {
  return SendGET(module, resource, params);
}
async function post(module, resource, body = {}) {
  return SendPOST(module, resource, body);
}
async function put(module, resource, body = {}) {
  return SendPUT(module, resource, body);
}
async function del(module, resource, body = {}) {
  return SendDelete(module, resource, body);
}

class ModuleRequest {
  constructor(module) {
    this.module = module;
  }
  async get (resource, params = {}) {
    for (let key in params) {
      params[key] = encodeURIComponent(params[key])
    }
    // const encoded = encodeURIComponent(file_path)
    return get(this.module, resource, params);
  }
  async put(resource, body = {}) {
    return put(this.module, resource, body);
  }
  async post(resource, body = {}) {
    return post(this.module, resource, body);
  }
  async del(resource, body = {}) {
    return del(this.module, resource, body);
  }
}


const accountSender = new ModuleRequest('account')
const appSender = new ModuleRequest('app')
const downloaderSender = new ModuleRequest('downloader')
const mach_mqttSender = new ModuleRequest('mach_mqtt')
const cloud_mqttSender = new ModuleRequest('cloud_mqtt')
const ssdpSender = new ModuleRequest('ssdp')


export {
  accountSender,
  appSender,
  downloaderSender,
  mach_mqttSender,
  cloud_mqttSender,
  ssdpSender

}